import { useEffect, useState } from 'react'

const EVENT_NAME = 'urlFilters:change'

const readUrlFilters = () => Object.fromEntries(
  new URLSearchParams(window.location.search).entries()
)

const shallowEqualEntries = (prev, next) => {
  const keys = Object.keys(prev)
  if (keys.length !== Object.keys(next).length)
    return false
  return keys.every(key => prev[key] === next[key])
}

export const updateUrlFilters = partial => {
  const params = new URLSearchParams(window.location.search)
  let changed = false

  Object.entries(partial).forEach(([key, value]) => {
    const isEmpty = value === null || value === '' || typeof value === 'undefined'
    const normalized = isEmpty ? null : String(value)
    const existing = params.get(key)
    if (normalized === null && existing !== null) {
      params.delete(key)
      changed = true
    } else if (normalized !== null && normalized !== existing) {
      params.set(key, normalized)
      changed = true
    }
  })

  if (!changed)
    return false

  const queryString = params.toString()
  const { pathname } = window.location
  const newUrl = queryString ? `${pathname}?${queryString}` : pathname
  window.history.replaceState(null, '', newUrl)
  window.dispatchEvent(new CustomEvent(EVENT_NAME))
  return true
}

export const useUrlFilters = () => {
  const [filters, setFilters] = useState(readUrlFilters)

  useEffect(() => {
    const handler = () => setFilters(prev => {
      const next = readUrlFilters()
      return shallowEqualEntries(prev, next) ? prev : next
    })
    window.addEventListener(EVENT_NAME, handler)
    window.addEventListener('popstate', handler)
    return () => {
      window.removeEventListener(EVENT_NAME, handler)
      window.removeEventListener('popstate', handler)
    }
  }, [])

  return filters
}
